import React, { useEffect } from "react";
import { PrimaryButton } from "./primary-button";

export function SuccessStep() {
  function transmitFinished() {
    window.parent.postMessage(
      {
        event: "workflowComplete",
      },
      "*"
    );
  }

  const handleClose = () => {
    transmitFinished();
  };

  return (
    <div>
      <div className="space-y-2">
        <h1 className="display-medium text-body">Success!</h1>
        <p className="body text-body">
          We'll be in touch when it's time to reorder.
        </p>
        <PrimaryButton onClick={handleClose}>Close</PrimaryButton>
      </div>
    </div>
  );
}
